module.exports = __webpack_public_path__ + "static/media/Screenshot_app_1.221d4dc6.png";